import React from "react";

import TenantContext from "./context";
import {
  getNextOpening,
  isStoreOpen,
  NextOpening,
} from "./utils/availableHours";
import { isPremiumPlan } from "./selectors";

export function useTenant() {
  const {
    state: {tenant},
  } = React.useContext(TenantContext);

  return tenant;
}

interface StoreOpenState {
  isOpen: boolean;
  nextOpening: NextOpening | null;
  hasSchedule: boolean;
}

export function useStoreOpen(): StoreOpenState {
  const { availableHours, tier } = useTenant();
  const scheduleEnabled = isPremiumPlan(tier);
  const hasSchedule = scheduleEnabled && Boolean(availableHours?.schedule?.length);

  const [state, setState] = React.useState<StoreOpenState>({
    isOpen: true,
    nextOpening: null,
    hasSchedule,
  });

  React.useEffect(() => {
    if (!scheduleEnabled || !availableHours) {
      setState({ isOpen: true, nextOpening: null, hasSchedule: false });
      return;
    }

    const evaluate = () => {
      const open = isStoreOpen(availableHours);
      setState({
        isOpen: open,
        nextOpening: open ? null : getNextOpening(availableHours),
        hasSchedule: true,
      });
    };

    evaluate();
    const interval = setInterval(evaluate, 60 * 1000);

    return () => clearInterval(interval);
  }, [availableHours, scheduleEnabled]);

  return state;
}
